<template>
<div class="chapter">
<div class="inner_page">
<p class="tp3" id="toc_marker-1" title="BOOK ONE: Foundational Considerations"><b>BOOK ONE</b></p>
<div class="sidebar">
<h6 class="sigil_not_in_toc" id="toc_marker-2">Foundational<br/>
    Considerations</h6>
</div>
<div class="lines2"><img alt="" class="img50" src="Images/arrow_line.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// BookOne.vue?3e71716e